import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic,
  BokkzAlgDataService, BokkzJrDataService
} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-eigen-vermogen-rechtspersoon',
  templateUrl: './spec-eigen-vermogen-rechtspersoon.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    SharedUiDialogModule,
    SharedUiButtonModule,
    CommonModule
  ],
  styleUrls: ['./spec-eigen-vermogen-rechtspersoon.component.scss']
})
export class SpecEigenVermogenRechtspersoonComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private destroy$ = new Subject<void>();
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;
  public heeftAandelen = false;
  public isCooperatie = false;
  public isEnkelvoudig = false;
  public isFiscaleGrondslagen = false;
  public isMicro = false;
  public isKlein = false;
  public isBalansNaResultaatbestemming = false;
  public openInfoVBalansNaResultaatbestemming = false;
  pendingValue: any;
  lastValue: any;
  public balanceSheetBeforeAfterAppropriationResultsFg = {} as FormGroup;

  public shareCapitalPaidCalledUpFg = {} as FormGroup;
  public sharePremiumFg = {} as FormGroup;
  public revaluationReserveFg = {} as FormGroup;
  public legalReservesFg = {} as FormGroup;
  public statutoryReservesFg = {} as FormGroup;
  public reservesOtherFg = {} as FormGroup;
  public reinvestmentReserveFg = {} as FormGroup;
  public otherFiscalReservesFg = {} as FormGroup;
  public resultForTheYearFg = {} as FormGroup;
  public retainedEarningsFg = {} as FormGroup;
  public equityFg = {} as FormGroup;
  public noncontrollingInterestFg = {} as FormGroup;
  public equityGroupFg = {} as FormGroup;

  public legalReserveNegativeTranslationShareCapitalIntoEurosFg = {} as FormGroup;
  public legalReserveTranslationShareCapitalIntoEurosFg = {} as FormGroup;
  public legalReserveContributionInKindFg = {} as FormGroup;
  public legalReserveLoansProvidedObtainTreasurySharesFg = {} as FormGroup;
  public legalReserveCostsIncorporationShareIssueFg = {} as FormGroup;
  public legalReserveDevelopmentFg = {} as FormGroup;
  public legalReserveParticipatingInterestsFg = {} as FormGroup;
  public reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterestsFg = {} as FormGroup;
  public foreignCurrencyTranslationReserveFg = {} as FormGroup;

  public shareCapitalPaidCalledUpDisclosureFg = {} as FormGroup;
  public sharePremiumDisclosureFg = {} as FormGroup;
  public revaluationReserveDisclosureFg = {} as FormGroup;
  public legalReservesDisclosureFg = {} as FormGroup;
  public statutoryReservesDisclosureFg = {} as FormGroup;
  public reservesOtherDisclosureFg = {} as FormGroup;
  public reinvestmentReserveDisclosureFg = {} as FormGroup;
  public otherFiscalReservesDisclosureFg = {} as FormGroup;
  public resultForTheYearDisclosureFg = {} as FormGroup;
  public retainedEarningsDisclosureFg = {} as FormGroup;
  public equityDisclosureFg = {} as FormGroup;
  public equityContinuityDisclosureFg = {} as FormGroup;
  public equityWithheldPartResultDescriptionFg = {} as FormGroup;
  public noncontrollingInterestDisclosureFg = {} as FormGroup;
  public equityGroupDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsVoorNaResultaatbestemming: SelectFormControlItem<string>[] = [
    {value: "VOOR", label: "Voor resultaatbestemming"},
    {value: "NA", label: "Na resultaatbestemming"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  onValueChange() {
    this.pendingValue=this.balanceSheetBeforeAfterAppropriationResultsFg.get('value')?.value;
    this.openInfoVBalansNaResultaatbestemming = true;
  }

  cancelChange() {
    this.balanceSheetBeforeAfterAppropriationResultsFg.get('value')?.setValue(this.lastValue, { emitEvent: false });
    this.openInfoVBalansNaResultaatbestemming = false;
    setTimeout(()=>{
      this.pendingValue = null;
    },250)  }

  confirmChange() {
    this.lastValue = this.pendingValue;
    this.saveForm();
    this.openInfoVBalansNaResultaatbestemming = false;
    setTimeout(()=>{
      this.pendingValue = null;
    },250)  }

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private cdRef: ChangeDetectorRef,
    public jrLogic: BokkzJrLogic) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }
    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ]).pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });
    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
    this.jrDataService.heeftAandelen.subscribe((value) => {
      this.heeftAandelen = value;
    })
    this.jrDataService.isCooperatie.subscribe((value) => {
      this.isCooperatie = value;
    })
    this.jrDataService.isEnkelvoudig.subscribe((value) => {
      this.isEnkelvoudig = value;
    })
    this.jrDataService.isFiscaleGrondslagen.subscribe((value) => {
      this.isFiscaleGrondslagen = value;
    })
    this.jrDataService.isMicro.subscribe((value) => {
      this.isMicro = value;
    })
    this.jrDataService.isKlein.subscribe((value) => {
      this.isKlein = value;
    })
    this.jrDataService.isBalansNaResultaatbestemming.subscribe((value) => {
      this.isBalansNaResultaatbestemming = value;
    })

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {

    this.balanceSheetBeforeAfterAppropriationResultsFg = this.jrDataService.createProfitAppropriationItem()
    this.shareCapitalPaidCalledUpFg = this.jrDataService.createFormGroupBalanceItem()
    this.sharePremiumFg = this.jrDataService.createFormGroupBalanceItem();
    this.revaluationReserveFg = this.jrDataService.createFormGroupBalanceItem();
    this.legalReservesFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues(); //heeft uitsplitsing
    this.statutoryReservesFg = this.jrDataService.createFormGroupBalanceItem();
    this.reservesOtherFg = this.jrDataService.createFormGroupBalanceItem();
    this.reinvestmentReserveFg = this.jrDataService.createFormGroupBalanceItem();
    this.otherFiscalReservesFg = this.jrDataService.createFormGroupBalanceItem();
    this.resultForTheYearFg = this.jrDataService.createFormGroupBalanceItem();
    this.retainedEarningsFg = this.jrDataService.createFormGroupBalanceItem();
    this.equityFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.noncontrollingInterestFg = this.jrDataService.createFormGroupBalanceItem();
    this.equityGroupFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();

    this.legalReserveNegativeTranslationShareCapitalIntoEurosFg = this.jrDataService.createFormGroupBalanceItem();
    this.legalReserveTranslationShareCapitalIntoEurosFg = this.jrDataService.createFormGroupBalanceItem();
    this.legalReserveContributionInKindFg = this.jrDataService.createFormGroupBalanceItem();
    this.legalReserveLoansProvidedObtainTreasurySharesFg = this.jrDataService.createFormGroupBalanceItem();
    this.legalReserveCostsIncorporationShareIssueFg = this.jrDataService.createFormGroupBalanceItem();
    this.legalReserveDevelopmentFg = this.jrDataService.createFormGroupBalanceItem();
    this.legalReserveParticipatingInterestsFg = this.jrDataService.createFormGroupBalanceItem();
    this.reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterestsFg = this.jrDataService.createFormGroupBalanceItem();
    this.foreignCurrencyTranslationReserveFg = this.jrDataService.createFormGroupBalanceItem();

    this.shareCapitalPaidCalledUpDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.sharePremiumDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.revaluationReserveDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.legalReservesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.statutoryReservesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.reservesOtherDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.reinvestmentReserveDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.otherFiscalReservesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.resultForTheYearDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.retainedEarningsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.equityDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.equityContinuityDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.equityWithheldPartResultDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();

    this.noncontrollingInterestDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.equityGroupDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {

    const item = value.rapportage?.jaarrekeningen?.at(0)?.balans;
    const text = value.rapportage?.jaarrekeningen?.at(0)?.balans;
    if (item) {

      this.equityFg.reset();
      this.equityGroupFg.reset();
      this.legalReservesFg.reset();

      if (item?.balanceSheetBeforeAfterAppropriationResults) {
        const subItem = item.balanceSheetBeforeAfterAppropriationResults;
        this.balanceSheetBeforeAfterAppropriationResultsFg.patchValue(subItem)
        this.lastValue = subItem.value
      }

      if (item?.aandelenkapitaal?.shareCapitalPaidCalledUp) {
        const subItem = item.aandelenkapitaal?.shareCapitalPaidCalledUp;
        this.shareCapitalPaidCalledUpFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.shareCapitalPaidCalledUpFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.agio?.sharePremium) {
        const subItem = item.agio.sharePremium;
        this.sharePremiumFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.sharePremiumFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.herwaarderingsreserve?.revaluationReserve) {
        const subItem = item.herwaarderingsreserve?.revaluationReserve;
        this.revaluationReserveFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revaluationReserveFg.get('trialBalanceItems') as FormArray)
      }

      //wijkt af, want is telling met lagere uitsplisting
      const andereWettelijkeReserves = item?.andereWettelijkeReserves;
      if (andereWettelijkeReserves) {
        if (andereWettelijkeReserves?.legalReserves) {
          this.legalReservesFg.patchValue(andereWettelijkeReserves.legalReserves, {emitEvent: false})
        }

        const andereWettelijkeReservesUitsplitsing = andereWettelijkeReserves?.andereWettelijkeReservesUitsplitsing;
        const andereWettelijkeReservesTekstueel = andereWettelijkeReserves?.andereWettelijkeReservesTekstueel;

        if (andereWettelijkeReservesUitsplitsing) {
          if (andereWettelijkeReservesUitsplitsing?.legalReserveNegativeTranslationShareCapitalIntoEuros) {
            const subItem = andereWettelijkeReservesUitsplitsing.legalReserveNegativeTranslationShareCapitalIntoEuros;
            this.legalReserveNegativeTranslationShareCapitalIntoEurosFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.legalReserveNegativeTranslationShareCapitalIntoEurosFg.get('trialBalanceItems') as FormArray)
          }
          if (andereWettelijkeReservesUitsplitsing?.legalReserveTranslationShareCapitalIntoEuros) {
            const subItem = andereWettelijkeReservesUitsplitsing.legalReserveTranslationShareCapitalIntoEuros;
            this.legalReserveTranslationShareCapitalIntoEurosFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.legalReserveTranslationShareCapitalIntoEurosFg.get('trialBalanceItems') as FormArray)
          }
          if (andereWettelijkeReservesUitsplitsing?.legalReserveContributionInKind) {
            const subItem = andereWettelijkeReservesUitsplitsing.legalReserveContributionInKind;
            this.legalReserveContributionInKindFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.legalReserveContributionInKindFg.get('trialBalanceItems') as FormArray)
          }
          if (andereWettelijkeReservesUitsplitsing?.legalReserveLoansProvidedObtainTreasuryShares) {
            const subItem = andereWettelijkeReservesUitsplitsing.legalReserveLoansProvidedObtainTreasuryShares;
            this.legalReserveLoansProvidedObtainTreasurySharesFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.legalReserveLoansProvidedObtainTreasurySharesFg.get('trialBalanceItems') as FormArray)
          }
          if (andereWettelijkeReservesUitsplitsing?.legalReserveCostsIncorporationShareIssue) {
            const subItem = andereWettelijkeReservesUitsplitsing.legalReserveCostsIncorporationShareIssue;
            this.legalReserveCostsIncorporationShareIssueFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.legalReserveCostsIncorporationShareIssueFg.get('trialBalanceItems') as FormArray)
          }
          if (andereWettelijkeReservesUitsplitsing?.legalReserveDevelopment) {
            const subItem = andereWettelijkeReservesUitsplitsing.legalReserveDevelopment;
            this.legalReserveDevelopmentFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.legalReserveDevelopmentFg.get('trialBalanceItems') as FormArray)
          }
          if (andereWettelijkeReservesUitsplitsing?.legalReserveParticipatingInterests) {
            const subItem = andereWettelijkeReservesUitsplitsing.legalReserveParticipatingInterests;
            this.legalReserveParticipatingInterestsFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.legalReserveParticipatingInterestsFg.get('trialBalanceItems') as FormArray)
          }
          if (andereWettelijkeReservesUitsplitsing?.reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterests) {
            const subItem = andereWettelijkeReservesUitsplitsing.reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterests;
            this.reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterestsFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterestsFg.get('trialBalanceItems') as FormArray)
          }
          if (andereWettelijkeReservesUitsplitsing?.foreignCurrencyTranslationReserve) {
            const subItem = andereWettelijkeReservesUitsplitsing.foreignCurrencyTranslationReserve;
            this.foreignCurrencyTranslationReserveFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.foreignCurrencyTranslationReserveFg.get('trialBalanceItems') as FormArray)
          }
        }
        if (andereWettelijkeReservesTekstueel) {
          if (andereWettelijkeReservesTekstueel.legalReservesDisclosure) {
            this.legalReservesDisclosureFg.patchValue(andereWettelijkeReservesTekstueel.legalReservesDisclosure);
          }
        }
      }
      if (item?.statutaireReserves?.statutoryReserves) {
        const subItem = item.statutaireReserves.statutoryReserves;
        this.statutoryReservesFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.statutoryReservesFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.herinvesteringsreserve?.reinvestmentReserve) {
        const subItem = item.herinvesteringsreserve.reinvestmentReserve;
        this.reinvestmentReserveFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.reinvestmentReserveFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.overigeReserves?.reservesOther) {
        const subItem = item.overigeReserves.reservesOther;
        this.reservesOtherFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.reservesOtherFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.overigeFiscaleReserves?.otherFiscalReserves) {
        const subItem = item.overigeFiscaleReserves.otherFiscalReserves;
        this.otherFiscalReservesFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.otherFiscalReservesFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.resultaatBoekjaar?.resultForTheYear) {
        const subItem = item.resultaatBoekjaar.resultForTheYear;
        this.resultForTheYearFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.resultForTheYearFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.nietVerdeeldeWinsten?.retainedEarnings) {
        const subItem = item.nietVerdeeldeWinsten.retainedEarnings;
        this.retainedEarningsFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.retainedEarningsFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.eigenVermogen?.equity) {
        const subItem = item.eigenVermogen.equity;
        this.equityFg.patchValue(subItem, {emitEvent: false})
      }
      if (item?.aandeelDerden?.noncontrollingInterest) {
        const subItem = item.aandeelDerden.noncontrollingInterest;
        this.noncontrollingInterestFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.noncontrollingInterestFg.get('trialBalanceItems') as FormArray)
      }
      if (item?.groepsvermogen?.equityGroup) {
        const subItem = item.groepsvermogen.equityGroup;
        this.equityGroupFg.patchValue(subItem, {emitEvent: false})
      }
    }
    if (text) {
      if (text.aandelenkapitaal?.aandelenkapitaalTekstueel) {
        if (text.aandelenkapitaal.aandelenkapitaalTekstueel.shareCapitalPaidCalledUpDisclosure) {
          this.shareCapitalPaidCalledUpDisclosureFg.patchValue(text.aandelenkapitaal.aandelenkapitaalTekstueel.shareCapitalPaidCalledUpDisclosure);
        }
      }
      if (text.agio?.agioTekstueel) {
        if (text.agio.agioTekstueel.sharePremiumDisclosure) {
          this.sharePremiumDisclosureFg.patchValue(text.agio.agioTekstueel.sharePremiumDisclosure);
        }
      }
      if (text.herwaarderingsreserve?.herwaarderingsreserveTekstueel) {
        if (text.herwaarderingsreserve.herwaarderingsreserveTekstueel.revaluationReserveDisclosure) {
          this.revaluationReserveDisclosureFg.patchValue(text.herwaarderingsreserve.herwaarderingsreserveTekstueel.revaluationReserveDisclosure);
        }
      }
      if (text.statutaireReserves?.statutaireReservesTekstueel) {
        if (text.statutaireReserves.statutaireReservesTekstueel.statutoryReservesDisclosure) {
          this.statutoryReservesDisclosureFg.patchValue(text.statutaireReserves.statutaireReservesTekstueel.statutoryReservesDisclosure);
        }
      }
      if (text.overigeReserves?.overigeReservesTekstueel) {
        if (text.overigeReserves.overigeReservesTekstueel.reservesOtherDisclosure) {
          this.reservesOtherDisclosureFg.patchValue(text.overigeReserves.overigeReservesTekstueel.reservesOtherDisclosure);
        }
      }
      if (text.herinvesteringsreserve?.herinvesteringsreserveTekstueel) {
        if (text.herinvesteringsreserve.herinvesteringsreserveTekstueel.reinvestmentReserveDisclosure) {
          this.reinvestmentReserveDisclosureFg.patchValue(text.herinvesteringsreserve.herinvesteringsreserveTekstueel.reinvestmentReserveDisclosure);
        }
      }
      if (text.overigeFiscaleReserves?.overigeFiscaleReservesTekstueel) {
        if (text.overigeFiscaleReserves.overigeFiscaleReservesTekstueel.otherFiscalReservesDisclosure) {
          this.otherFiscalReservesDisclosureFg.patchValue(text.overigeFiscaleReserves.overigeFiscaleReservesTekstueel.otherFiscalReservesDisclosure);
        }
      }
      if (text.resultaatBoekjaar?.resultaatBoekjaarTekstueel) {
        if (text.resultaatBoekjaar.resultaatBoekjaarTekstueel.resultForTheYearDisclosure) {
          this.resultForTheYearDisclosureFg.patchValue(text.resultaatBoekjaar.resultaatBoekjaarTekstueel.resultForTheYearDisclosure);
        }
      }
      if (text.nietVerdeeldeWinsten?.nietVerdeeldeWinstenTekstueel) {
        if (text.nietVerdeeldeWinsten.nietVerdeeldeWinstenTekstueel.retainedEarningsDisclosure) {
          this.retainedEarningsDisclosureFg.patchValue(text.nietVerdeeldeWinsten.nietVerdeeldeWinstenTekstueel.retainedEarningsDisclosure);
        }
      }
      if (text.eigenVermogen?.eigenVermogenTekstueel) {
        if (text.eigenVermogen.eigenVermogenTekstueel.equityDisclosure) {
          this.equityDisclosureFg.patchValue(text.eigenVermogen.eigenVermogenTekstueel.equityDisclosure);
        }
        if (text.eigenVermogen.eigenVermogenTekstueel.equityContinuityDisclosure) {
          this.equityContinuityDisclosureFg.patchValue(text.eigenVermogen.eigenVermogenTekstueel.equityContinuityDisclosure);
        }
        if (text.eigenVermogen.eigenVermogenTekstueel.equityWithheldPartResultDescription) {
          this.equityWithheldPartResultDescriptionFg.patchValue(text.eigenVermogen.eigenVermogenTekstueel.equityWithheldPartResultDescription);
        }
      }

      if (text.aandeelDerden?.aandeelDerdenTekstueel) {
        if (text.aandeelDerden.aandeelDerdenTekstueel.noncontrollingInterestDisclosure) {
          this.noncontrollingInterestDisclosureFg.patchValue(text.aandeelDerden.aandeelDerdenTekstueel.noncontrollingInterestDisclosure);
        }
      }
      if (text.groepsvermogen?.groepsVermogenTekstueel) {
        if (text.groepsvermogen.groepsVermogenTekstueel.equityGroupDisclosure) {
          this.equityGroupDisclosureFg.patchValue(text.groepsvermogen.groepsVermogenTekstueel.equityGroupDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i], {emitEvent: false});
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup, {emitEvent: false});
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.balanceSheetBeforeAfterAppropriationResultsFg.updateValueAndValidity({ emitEvent: false })
    this.shareCapitalPaidCalledUpFg.updateValueAndValidity({ emitEvent: false });
    this.sharePremiumFg.updateValueAndValidity({ emitEvent: false });
    this.revaluationReserveFg.updateValueAndValidity({ emitEvent: false });
    this.legalReservesFg.updateValueAndValidity({ emitEvent: false });
    this.statutoryReservesFg.updateValueAndValidity({ emitEvent: false });
    this.reinvestmentReserveFg.updateValueAndValidity({ emitEvent: false });
    this.reservesOtherFg.updateValueAndValidity({ emitEvent: false });
    this.otherFiscalReservesFg.updateValueAndValidity({ emitEvent: false });
    this.resultForTheYearFg.updateValueAndValidity({ emitEvent: false });
    this.retainedEarningsFg.updateValueAndValidity({ emitEvent: false });
    this.equityFg.updateValueAndValidity({ emitEvent: false });
    this.noncontrollingInterestFg.updateValueAndValidity({ emitEvent: false });
    this.equityGroupFg.updateValueAndValidity({ emitEvent: false });

    this.legalReserveNegativeTranslationShareCapitalIntoEurosFg.updateValueAndValidity({ emitEvent: false });
    this.legalReserveTranslationShareCapitalIntoEurosFg.updateValueAndValidity({ emitEvent: false });
    this.legalReserveContributionInKindFg.updateValueAndValidity({ emitEvent: false });
    this.legalReserveLoansProvidedObtainTreasurySharesFg.updateValueAndValidity({ emitEvent: false });
    this.legalReserveCostsIncorporationShareIssueFg.updateValueAndValidity({ emitEvent: false });
    this.legalReserveDevelopmentFg.updateValueAndValidity({ emitEvent: false });
    this.legalReserveParticipatingInterestsFg.updateValueAndValidity({ emitEvent: false });
    this.reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterestsFg.updateValueAndValidity({ emitEvent: false });
    this.foreignCurrencyTranslationReserveFg.updateValueAndValidity({ emitEvent: false });

    this.shareCapitalPaidCalledUpDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.sharePremiumDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.revaluationReserveDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.legalReservesDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.statutoryReservesDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.reservesOtherDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.reinvestmentReserveDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.otherFiscalReservesDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.resultForTheYearDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.retainedEarningsDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.equityDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.equityContinuityDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.equityWithheldPartResultDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.noncontrollingInterestDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.equityGroupDisclosureFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans,
          balanceSheetBeforeAfterAppropriationResults: {value: this.balanceSheetBeforeAfterAppropriationResultsFg.getRawValue().value},
          aandelenkapitaal: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.aandelenkapitaal,
            shareCapitalPaidCalledUp: this.shareCapitalPaidCalledUpFg.value,
            aandelenkapitaalTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.aandelenkapitaal?.aandelenkapitaalTekstueel,
              shareCapitalPaidCalledUpDisclosure: this.shareCapitalPaidCalledUpDisclosureFg.value,
            }
          },
          agio: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.agio,
            sharePremium: this.sharePremiumFg.value,
            agioTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.agio?.agioTekstueel,
              sharePremiumDisclosure: this.sharePremiumDisclosureFg.value,
            }
          },
          herwaarderingsreserve: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.herwaarderingsreserve,
            revaluationReserve: this.revaluationReserveFg.value,
            herwaarderingsreserveTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.herwaarderingsreserve?.herwaarderingsreserveTekstueel,
              revaluationReserveDisclosure: this.revaluationReserveDisclosureFg.value,
            }
          },
          andereWettelijkeReserves: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.andereWettelijkeReserves,
            andereWettelijkeReservesUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.andereWettelijkeReserves?.andereWettelijkeReservesUitsplitsing,
              legalReserveNegativeTranslationShareCapitalIntoEuros: this.legalReserveNegativeTranslationShareCapitalIntoEurosFg.value,
              legalReserveTranslationShareCapitalIntoEuros: this.legalReserveTranslationShareCapitalIntoEurosFg.value,
              legalReserveContributionInKind: this.legalReserveContributionInKindFg.value,
              legalReserveLoansProvidedObtainTreasuryShares: this.legalReserveLoansProvidedObtainTreasurySharesFg.value,
              legalReserveCostsIncorporationShareIssue: this.legalReserveCostsIncorporationShareIssueFg.value,
              legalReserveDevelopment: this.legalReserveDevelopmentFg.value,
              legalReserveParticipatingInterests: this.legalReserveParticipatingInterestsFg.value,
              reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterests: this.reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterestsFg.value,
              foreignCurrencyTranslationReserve: this.foreignCurrencyTranslationReserveFg.value,
            },
            andereWettelijkeReservesTekstueel: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.andereWettelijkeReserves?.andereWettelijkeReservesTekstueel,
              legalReservesDisclosure: this.legalReservesDisclosureFg.value,
            }
          },
          statutaireReserves: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.statutaireReserves,
            statutoryReserves: this.statutoryReservesFg.value,
            statutaireReservesTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.statutaireReserves?.statutaireReservesTekstueel,
              statutoryReservesDisclosure: this.statutoryReservesDisclosureFg.value,
            }
          },
          overigeReserves: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.overigeReserves,
            reservesOther: this.reservesOtherFg.value,
            overigeReservesTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.overigeReserves?.overigeReservesTekstueel,
              reservesOtherDisclosure: this.reservesOtherDisclosureFg.value,
            }
          },
          herinvesteringsreserve: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.herinvesteringsreserve,
            reinvestmentReserve: this.reinvestmentReserveFg.value,
            herinvesteringsreserveTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.herinvesteringsreserve?.herinvesteringsreserveTekstueel,
              reinvestmentReserveDisclosure: this.reinvestmentReserveDisclosureFg.value,
            }
          },
          overigeFiscaleReserves: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.overigeFiscaleReserves,
            otherFiscalReserves: this.otherFiscalReservesFg.value,
            overigeFiscaleReservesTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.overigeFiscaleReserves?.overigeFiscaleReservesTekstueel,
              otherFiscalReservesDisclosure: this.otherFiscalReservesDisclosureFg.value,
            }
          },
          resultaatBoekjaar: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.resultaatBoekjaar,
            resultaatBoekjaarTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.resultaatBoekjaar?.resultaatBoekjaarTekstueel,
              resultForTheYearDisclosure: this.resultForTheYearDisclosureFg.value,
            }
          },
          nietVerdeeldeWinsten: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.nietVerdeeldeWinsten,
            retainedEarnings: this.retainedEarningsFg.value,
            nietVerdeeldeWinstenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.nietVerdeeldeWinsten?.nietVerdeeldeWinstenTekstueel,
              retainedEarningsDisclosure: this.retainedEarningsDisclosureFg.value,
            }
          },
          eigenVermogen: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.eigenVermogen,
            eigenVermogenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.eigenVermogen?.eigenVermogenTekstueel,
              equityDisclosure: this.equityDisclosureFg.value,
              equityContinuityDisclosure: this.equityContinuityDisclosureFg.value,
              equityWithheldPartResultDescription: this.equityWithheldPartResultDescriptionFg.value,
            }
          },
          aandeelDerden: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.aandeelDerden,
            noncontrollingInterest: this.noncontrollingInterestFg.value,
            aandeelDerdenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.aandeelDerden?.aandeelDerdenTekstueel,
              noncontrollingInterestDisclosure: this.noncontrollingInterestDisclosureFg.value,
            }
          },
          groepsvermogen: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.groepsvermogen,
            groepsVermogenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.balans?.groepsvermogen?.groepsVermogenTekstueel,
              equityGroupDisclosure: this.equityGroupDisclosureFg.value,
            }
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogic.getCalculation(this.jrEntity);
  }

}
